import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import {
  PageHeader,
  PostDetailComponent,
  PostImageComponent,
} from "components";
import { getPostDetail, getPostLike } from "apis";
import { PostDTO } from "types";

export default function Post() {
  const params = useParams();
  const postId = params.id;

  const [postDetail, setPostDetail] = useState<PostDTO>();
  const [postLike, setPostLike] = useState<boolean>(false);

  const getDetail = async () => {
    if (postId) {
      const response = await getPostDetail(postId);
      if (response.status === 200) {
        setPostDetail(response.data.data);
      }
    }
  };

  const fetchInitialLikeState = async () => {
    try {
      if (postId) {
        const response = await getPostLike(postId);
        if (response.data.isSuccess === "T") {
          setPostLike(response.data.data);
        }
      }
    } catch (error) {
      console.error("초기 좋아요 상태를 가져오는 데 실패했습니다.", error);
    }
  };

  useEffect(() => {
    if (postId) {
      getDetail();
      fetchInitialLikeState();
    }
  }, [postId]);

  return (
    <div className="animate-fadeUp mobile:pb-[56px]">
      <PageHeader title="포스트" isArrow={true} />
      <div className="bg-white rounded-2xl overflow-hidden mobile:rounded-none">
        <div className="flex p-6 gap-6 mobile:flex-col mobile:py-4 mobile:px-0">
          <div className="flex flex-1 flex-col mobile:px-4">
            <PostImageComponent images={postDetail?.images} />
          </div>
          <div className="w-[300px] flex-shrink-0 mobile:w-full mobile:px-4">
            <PostDetailComponent
              post={postDetail!}
              like={postLike!}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
